<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" />
    <div class="banner-box">
      <img :src="bg" alt="">
      <div class="title">
        <p>智绘商城</p>
      </div>
    </div>
    <div class="product-box">
      <div class="title">
        <p>智绘硬件商品</p>
        <p><span>共</span><span style="color: #FCBD01">{{product.length}}</span><span>个商品</span></p>
      </div>
      <ul class="product">
        <li v-for="(item, index) in product" :key="index">
           <el-image
              class="img"
              :src="item.img[0]"
              :preview-src-list="item.img">
            </el-image>
            <p class="name">{{item.name}}</p>
        </li>
      </ul>
    </div>
    <footer-a />
    <back-top />
  </div>
</template>

<script>
import bg from '../assets/images/mall/bg.png'
import product from '../assets/json/product'
import navTop from '../components/nav'
import footerA from '../components/footer'
import backTop from '../components/backTop'
export default {
  data () {
    return {
      bg: bg,
      product: product,
      topIndex: 3
    }
  },
  components: {navTop, footerA, backTop}
}
</script>

<style scoped>
  .banner-box{
    position: relative;
    width: 100%;
    height: 400px;
  }
  .banner-box>img{
    width: 100%;
    height: 100%;
  }
  .banner-box .title{
    position: absolute;
    top: 50%;
    left: 50%;
    color: #ffffff;
    border: 1px solid #ffffff;
    font-size:50px;
    font-family:PingFang SC;
    font-weight:600;
    transform: translate(-50%, -50%);
    padding: 30px 100px;
  }
  .product-box{
    padding: 52px 360px 52px;
    background:rgba(247,248,248,1);
  }
  .product-box .title{
    display: flex;
    justify-content: space-between;
    font-size:16px;
    font-family:Source Han Sans CN;
    font-weight:500;
    line-height:21px;
    color:rgba(102,102,102,1);
    opacity:1;
    padding-bottom: 19px;
  }
  .product-box .product{
    display: flex;
    justify-content: left;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 19px;
    border-top:1px solid rgba(237,237,237,1);
  }
  .product-box .product>li{
    width: 262px;
    margin-right: 40px;
    border: 1px solid #cccccc;
    margin-bottom: 40px;
    transition: all 0.5s;
    cursor: pointer;
    background: #ffffff;
  }
  .product-box .product>li:hover{
    box-shadow:0px 0px 20px rgba(0,0,0,0.16);
    border: 1px solid #ffffff;
  }
  .product-box .product>li:nth-child(4n){
    margin-right: 0;
  }
  .img{
    height: 270px;
  }
  .name{
    border-top: 1px solid #cccccc;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:50px;
    color:rgba(51,51,51,1);
    background: #ffffff;
  }
  .product >>> .el-icon-circle-close{
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/mall.vue